export class Loading {
  constructor() {
    if (Loading.instance) {
      return Loading.instance;
    }
    Loading.instance = this;
    this.loadingModal = document.querySelector("#loading");
  }

  hiddenModalLoading() {
    this.loadingModal.classList.add("hidden");
  }
}
